export default [{
	titulo: 'Usuários',
	icone: 'menu-icon fa fa-caret-right',
	url: '/admin/usuarios',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]